import { useState, useCallback } from "react";

const DEFAULT_NOTIFICATION = { show: false, message: "", type: "info" };

const useNotificationState = () => {
  const [notification, setNotification] = useState(DEFAULT_NOTIFICATION);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const [currentToastNotification, setCurrentToastNotification] = useState(null);
  const [notificationCenterOpen, setNotificationCenterOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const showNotification = useCallback((message, type = "info", duration = 3000) => {
    setNotification({ show: true, message, type });
    setTimeout(() => {
      setNotification(DEFAULT_NOTIFICATION);
    }, duration);
  }, []);

  return {
    notification,
    showNotification,
    unreadNotificationCount,
    setUnreadNotificationCount,
    currentToastNotification,
    setCurrentToastNotification,
    notificationCenterOpen,
    setNotificationCenterOpen,
    notifications,
    setNotifications,
  };
};

export default useNotificationState;
